declare global {
	interface ArrayBuffer {
		toUint8Array(): Uint8Array;
	}
}

var toUint8ArrayPolyfill = () => {
	ArrayBuffer.prototype.toUint8Array = function (): Uint8Array {
		return new Uint8Array(this);
	}
}

var setupArrayBufferPolyFills = () => {
	toUint8ArrayPolyfill();
}

export default setupArrayBufferPolyFills;